import { isV4Format } from 'ip';
import { type Branded, brand } from '../Branded';
import { Ipv4SubnetStringError } from './non-empty-ipv4-subnet-string-error';
import { isNonEmptyString } from './non-empty-string';
import { NonEmptyStringError } from './non-empty-string-error';

export type NonEmptyIPv4SubnetString = Branded<
  string,
  'nonEmptyIPv4SubnetString'
>;

export function asNonEmptyIpv4SubnetString(
  value: string,
): NonEmptyIPv4SubnetString {
  if (!isNonEmptyString(value)) {
    throw new NonEmptyStringError(value);
  }
  if (!isValidIPv4Subnet(value)) {
    throw new Ipv4SubnetStringError(value);
  }
  return brand<NonEmptyIPv4SubnetString>(value);
}

export function isNonEmptyIpv4SubnetString(
  value: string,
): value is NonEmptyIPv4SubnetString {
  return value.length > 0 && isValidIPv4Subnet(value);
}

function isValidIPv4Subnet(value: string): boolean {
  try {
    const [ipPart, mask] = value.split('/');
    if (!mask || Number.isNaN(mask)) {
      return false;
    }

    const prefix = Number.parseInt(mask, 10);
    if (prefix < 0 || prefix > 32) {
      return false;
    }

    return ipPart ? isV4Format(ipPart) : false;
  } catch {
    return false;
  }
}
